/* eslint-disable no-restricted-globals */
import { DateFilter, FilterGroup, FilterOperation } from '../types';
import { isDateField } from './helpers';

export const doesProspectFilterHasErrors = (
  filterGroups: FilterGroup[],
  fields?: any[],
): boolean =>
  filterGroups.some((group) =>
    group.conditions.some((condition) => {
      const { field, operation, value } = condition;

      // Case 1: If the field is null no need to validate
      if (!field) return false;

      // Case 2: If field has a value but operation is null
      if (field && !operation) return true;

      // Case 3: If field and operation are defined but value is missing,
      // and the operation is not IS_EMPTY or IS_NOT_EMPTY
      if (
        field &&
        operation &&
        (value === undefined ||
          value === null ||
          value === '' ||
          (Array.isArray(value) && value.length === 0)) &&
        operation !== FilterOperation.IS_EMPTY &&
        operation !== FilterOperation.IS_NOT_EMPTY
      ) {
        return true;
      }

      // Case 4: If the operation is BETWEEN but value doesn't have length 2
      if (
        field &&
        operation === FilterOperation.BETWEEN &&
        (!Array.isArray(value) ||
          value.length !== 2 ||
          value[0] === '' ||
          value[1] === '' ||
          isNaN(Number(value[0])) ||
          isNaN(Number(value[1])))
      ) {
        return true;
      }

      // Case 5: If the field is a date field,
      // and the operation is IS or IS_WITHIN but value doesn't have length 2
      // Skip validation for IS_EMPTY and IS_NOT_EMPTY operations
      if (
        isDateField(field, fields) &&
        operation !== FilterOperation.IS_EMPTY &&
        operation !== FilterOperation.IS_NOT_EMPTY
      ) {
        if (Object.values(DateFilter).includes(value as DateFilter)) {
          return false;
        }

        if (!Array.isArray(value)) {
          return true;
        }

        if (
          (operation === FilterOperation.IS ||
            operation === FilterOperation.IS_WITHIN) &&
          (value.length !== 2 ||
            value[0] === null ||
            value[0] === '' ||
            value[1] === null ||
            value[1] === '')
        ) {
          return true;
        }
      }

      return false; // No errors found in this condition
    }),
  );
